module.exports = "https://cdn-static.chanmama.com/sub-module/static-file/2/7/3b49494922"